import axios from 'axios';

import TRANSLATIONS from '../translations/translations@default.json';

export function composeListerQuery(url) {
	if (url === 'null' || !url) {
		console.error(`url is a required parameter: url >${url}<`);
		return Promise.reject('url is a required parameter');
	}

	const relativeUrlStripOrigin = url.replace(window.location.origin, '');
	const relativeUrl = encodeURIComponent(relativeUrlStripOrigin);

	return axios.get(`/api/lister?furl=${relativeUrl}`);
}

export const convertStringToValidHtml = (string) => {
	if (string && typeof string === 'string') {
		const conversion = document.createElement('div');
		conversion.innerHTML = string;
		const conversionContent = conversion.textContent;

		return conversionContent;
	}

	return null;
};

export const parseRatingClass = (rating) => {
	if (rating) {
		if (rating % 1 === 0) {
			return `${rating.toString()}-0`;
		}

		return rating.toString().split('.').join('-');
	}

	return null;
};

export function cookie(name) {
	return {
		get() {
			const nameEQ = `${name}=`;
			const docCookie = document.cookie;

			if (docCookie.indexOf(nameEQ) === -1) {
				return null;
			}

			return docCookie
				.split(';')
				.map((item) => item.trim())
				.filter((item) => item.includes(nameEQ))
				.shift()
				.split('=')[1];
		},

		set(value, days) {
			let expires;

			if (days) {
				const date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = `; expires=${date.toGMTString()}`;
			} else {
				expires = '';
			}

			document.cookie = `${name}=${value}${expires}; path=/`;
		},

		remove() {
			this.set('', -1);
		},
	};
}

export function validateUkPhoneNumber(phoneNumber) {
	const pattern = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
	const isValid = pattern.test(phoneNumber);

	return isValid;
}

export function validateEmail(email) {
	const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	const isValid = pattern.test(email);

	return isValid;
}

export const nested = (obj) => {
	if (obj.constructor !== Object) {
		throw new Error('nested() first argument needs to be an Object');
	}

	return {
		get(arr) {
			return arr.reduce(function (a, b) {
				return a && a[b] ? a[b] : null;
			}, obj);
		},

		set(arr, val) {
			const setObj = Object.assign({}, obj);

			return arr.reduce(function (a, b, index) {
				if (a && a[b] && index + 1 !== arr.length) {
					return a && a[b] ? a[b] : null;
				}

				a[b] = val;
				return setObj;
			}, setObj);
		},
	};
};

export function oosEndpoint(url) {
	// Only set up to work for AOL as OOS is only on AOL
	let endpoint;

	switch (url) {
		case 'ao.com':
			endpoint = '//api.ao.com/oossubscription/v1.0';
			break;
		case 'staging-aol.ao-qa.com':
			endpoint =
				'//xgzxztju3b.execute-api.eu-west-1.amazonaws.com/staging/oossubscription/v1.0';
			break;
		case 'beta-aol.ao-qa.com':
			endpoint =
				'//i6ik0dbksl.execute-api.eu-west-1.amazonaws.com/test/oossubscription/v1.0';
			break;
		default:
			endpoint =
				'//i6ik0dbksl.execute-api.eu-west-1.amazonaws.com/test/oossubscription/v1.0';
	}

	return endpoint;
}

export function removeWhitespace(string) {
	if (string) {
		const newString = string
			.replace(/\s+/g, ' ')
			.replace(/£\s/g, '£')
			.replace(/\s€/g, '€');

		return newString;
	}

	return false;
}

export function getParameterByName(name) {
	if (name && typeof name === 'string') {
		var match = new RegExp('[?&]' + name + '=([^&]*)').exec(
			window.location.search
		);
		return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
	}

	throw new Error();
}

export function scrollToTopOfLister(largeLayoutScrollToTop) {
	const listerAppContainer = document.querySelector('.lister');

	if (listerAppContainer) {
		if (largeLayoutScrollToTop) {
			setTimeout(() => {
				if (listerAppContainer.offsetTop < window.scrollY) {
					window.scrollTo({
						top: listerAppContainer.offsetTop,
						left: 0,
						behavior: 'smooth',
					});

					return true;
				} else if (listerAppContainer.offsetTop < window.pageYOffset) {
					// IE11
					window.scrollTo(0, listerAppContainer.offsetTop);

					return true;
				}

				return false;
			}, 1000);
		} else {
			setTimeout(() => {
				if (listerAppContainer.offsetTop < window.scrollY) {
					window.scrollTo({
						top: listerAppContainer.offsetTop,
						left: 0,
						behavior: 'smooth',
					});

					return true;
				}

				return false;
			}, 0);
		}
	}

	return false;
}

export function updateBasket(basketItemCount) {
	if (basketItemCount <= 0) return;

	const headerBasketCount = document.getElementById('basketCount');

	if (headerBasketCount) {
		headerBasketCount.classList.add('basketWithItems');
		headerBasketCount.classList.remove('noItems');
		headerBasketCount.textContent = basketItemCount;
	}
}

export function addToBasket(
	sku,
	{ addToBasketTimeStamp, addToBasketTimeStampHash }
) {
	const url = `${
		window.checkoutUrlPrefix
	}/HttpHandlers/AddToBasketHandler.ashx?action=ADD-SUMMARY&ProductCode=${encodeURIComponent(
		sku
	)}&timestamp=${addToBasketTimeStamp}&h=${addToBasketTimeStampHash}
	`;

	return axios({
		headers: { 'content-type': 'application/json' },
		method: 'post',
		url: url,
		withCredentials: true,
	}).then(({ data }) => data);
}

export function navigateToBasket() {
	window.location.assign(`${window.checkoutUrlPrefix}/shoppingbasket.aspx`);
}

// eslint-disable-next-line max-params
export function formatSelectedFacetsForTagging(data) {
	if (data) {
		const { facetTypeHeader, facetValues, pageUrl, pageTitle } = data;

		if (facetTypeHeader && facetValues && pageUrl && pageTitle) {
			let formattedString = '';

			facetValues.forEach((facetValue) => {
				const facetValueName = facetValue.Name;
				const currentPageTitle = pageTitle;
				const currentPagePathname = pageUrl.replace('#', '').split('?')[0];

				formattedString = `${facetTypeHeader}|${facetValueName}|${currentPageTitle}|${currentPagePathname}`;
			});

			return formattedString;
		}
	}

	return '';
}

// eslint-disable-next-line max-params
export function formatSelectedFacetForTagging(data) {
	if (data) {
		const {
			facetTypeHeader,
			facetTypePosition,
			facetValue,
			facetValuePosition,
			pageUrl,
			pageTitle,
		} = data;

		if (
			facetTypeHeader &&
			facetTypePosition >= 0 &&
			facetValue &&
			facetValuePosition >= 0 &&
			pageUrl &&
			pageTitle
		) {
			const facetValueName = facetValue.Name;
			const currentPageTitle = pageTitle;
			const currentPagePathname = pageUrl.replace('#', '').split('?')[0];

			const formattedString = `${facetTypeHeader}|${facetValueName}|${facetTypePosition}_${facetValuePosition}|${currentPageTitle}|${currentPagePathname}`;

			return formattedString;
		}
	}

	return '';
}

export const translateQueryString = (url) => {
	url = url.replace(/sort=/, `${TRANSLATIONS.queryTerms.sort}=`);

	url = url.replace(/pagesize=/, `${TRANSLATIONS.queryTerms.pagesize}=`);

	return url;
};

export const noDeliveryDate = 'No delivery date specified';

export function getDeliveryDate(deliveryMessage) {
	let deliveryDate = noDeliveryDate;

	if (deliveryMessage) {
		const spanContent = deliveryMessage.match(/(<span>).*(<\/span>)/g);

		if (spanContent) {
			deliveryDate = spanContent[0].slice(6, -7).replace('&nbsp;', ' ');
		}
	}

	return deliveryDate;
}

export function getDeliveryDaysDifference(deliveryDate) {
	const now = new Date();

	const delivery = new Date(
		`${deliveryDate.replace(/(th|st|nd|rd)/i, '')}, ${now.getFullYear()}`
	);

	const result = Math.round(delivery.getTime() - now.getTime()) / 86400000;

	return result.toFixed(0);
}

export const isBrowserIE11 = () => {
	return !!window.MSInputMethodContext && !!document.documentMode;
};

export const isTouchScreenDevice = () => {
	let isTouchScreen = false;

	const isIE11 = isBrowserIE11();

	if (
		'ontouchstart' in window ||
		(window.navigator.msPointerEnabled && !isIE11) ||
		'ontouchstart' in document.documentElement
	) {
		isTouchScreen = true;
	}

	return isTouchScreen;
};
